module.exports = __webpack_public_path__ + "img/15.bcc3dbf3.png";